import styled from "styled-components";
import { ReactComponent as EditIcon } from 'icons/edit-icon-small.svg'
import { ReactComponent as ReportIcon } from 'icons/report.svg'
import { ReactComponent as DeleteIcon } from 'icons/trash-icon.svg'
import { Box, IconButton } from "@material-ui/core";
import { Delete, History } from "@material-ui/icons";


export const StyledEditIcon = styled(EditIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    width: 0.8em;
    height: 0.8em;
  }
`


export const StyledReportIcon = styled(ReportIcon)`
&& {
  fill: ${props => props.theme.colors.accent1};
  width: 0.8em;
  height: 0.8em;
}
`

export const StyledDeleteIcon = styled(DeleteIcon)`
&& {
  fill: ${props => props.theme.colors.accent1};
  width: 0.8em;
  height: 0.8em;
}
`


export const StyledContextIconButton = styled(IconButton)`
  && {
    height: 0.5em;
    disabled: ${props => props.theme.colors.supplementary};
  }
`


export const StyledLargeDeleteIcon = styled(Delete)`
&& {
  fill: ${props => props.theme.colors.accent1};
}
`


export const StyledCommentBox = styled(Box)`
white-space: pre-wrap;
text-align: left;

&& {
  color: ${props => props.theme.colors.accent1};
}

a,
a:link,
a:visited {
  color: ${props => props.theme.colors.primary} !important;
}
`

export const StyledHistoryIcon = styled(History)`
&& {
  fill: ${props => props.theme.colors.accent1};
  width: 0.8em;
  height: 0.8em;
  margin-left: -0.1em;
}
`